/**
 * Override default behavior when setting invalid messages
 *
 * As of the time of this writing, GOUI has a limited range of invalidation messages. IFW is a bit more elaborate. Also,
 * the messages should be retrieved from the own translation files, not the GOUI translations, as these are native to the
 * browser
 */
import {DateField, TextField, t} from "@intermesh/goui";

export type ValidationErrorMessage = {
	code: string,
	data?: {
		min?: number,
		max?: number
	}
}
export class IfwInvalidator {
	/**
	 * Set a translated text field error message from the own translations
	 *
	 * @param ev
	 */
	public static setTranslatedErrorMsg(ev:any) {
		if (ev.target.input && !ev.target.input.validity.valid) {
			const validity = ev.target.input.validity;
			let msg = "Error";
			if (validity.valueMissing) {
				msg = "This field is required";
			} else if (validity.tooLong) {
				msg = "This field is too long";
			} else if (validity.tooShort) {
				msg = "This field is too short";
			}
			ev.target.invalidMsg = t(msg);
		}
	}

	public static setTranslatedEmailErrorMsg(ev:any) {
		if (ev.target.input && !ev.target.input.validity.valid) {
			const validity = ev.target.input.validity;
			let msg = "The e-mail address is invalid";
			if (validity.valueMissing) {
				msg = "This field is required";
			} else if (validity.tooLong) {
				msg = "This field is too long";
			} else if (validity.tooShort) {
				msg = "This field is too short";
			}
			ev.target.invalidMsg = t(msg);
		}
	}

	/**
	 * Set a translated date field error message from the own translations
	 *
	 * @param ev
	 */
	public static setTranslatedDateErrorMsg(ev: any) {
		ev.target.invalidMsg = t(ev.target.invalidMsg);
		ev.target.setInvalid(t(ev.target.invalidMsg)); // This should be public?
	}

	/**
	 * When unsuccessfully (re-)setting a password, parse the code, apply the IFW translation and set the invalid message
	 *
	 * @param fld
	 * @param validationMsg
	 */
	public static setInvalidPasswordMessage(fld: TextField, validationMsg: ValidationErrorMessage) {
		let msg = "";
		switch (validationMsg.code) {
			case "TOO_SHORT":
				const minLength = validationMsg.data!.min;
				msg += t("This password is too short. Please choose a password with a minimum of {min} characters.")
					.replace("{min}", minLength);
				break;
			case "NOT_COMPLEX":
				msg += t("Use at least 3 of the following types of characters: lowercase letters, uppercase letters, numbers, special characters.");
				break;
			case "USED_BEFORE":
				msg += t("You cannot reuse an old password. Please choose a new password.");
				break;
			case "IS_POWNED":
				msg += t("This password has been previously exposed in data breaches. Please choose another password.");
				break;
			case  "EQ_USER":
				msg += t("You cannot use your username as password. Please choose another password.")
				break;
			case "RESETPASS_TOKEN_INVALID":
				msg += t("EXCEPTION_RESETPASS_TOKEN_INVALID");
				break;
			default:
				msg += t("This field is required");
				break;
		}
		fld.setInvalid(msg);
	}
}